module.exports = __webpack_public_path__ + "static/img/companyProducts5.5fc9a47a.png";